export enum Vendor {
    Microsoft = 0,
    LinkedIn = 1,
    Other = 100
}